<template>
  <BaseButton primary @click="openNewProjectDialog"> New Project </BaseButton>
</template>

<script>
import { accountProjectsClient } from '@/api/clients';

export default {
  props: {
    accountId: {
      type: String,
      default: null,
    },
  },
  methods: {
    submit(data) {
      return accountProjectsClient.store(this.accountId, data);
    },
    openNewProjectDialog() {
      this.$modal.show({
        component: () => import('./CreateProjectDialog.vue'),
        props: {
          accountId: this.accountId,
        },
        on: {
          created: (project) => {
            this.$router.push({
              name: 'accounts.projects.project',
              params: { accountId: this.accountId, projectId: project.uuid },
            });
          },
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
